import { CheckboxGroupSkeleton } from '../../../../../../Checkbox'
import { LISTING_FORM_PORTALS_SKELETON_ROWS_LENGTH } from '../PortalsField.constants'

import { PortalsFieldCheckbox } from './PortalsFieldCheckbox'

import * as styles from './PortalsFieldCheckboxGroup.module.css'

function PortalsFieldCheckboxGroup({
  disabled,
  disabledReason,
  isLoading,
  portals,
  value,
  onChange,
}) {
  return isLoading ? (
    <CheckboxGroupSkeleton
      className={styles.checkboxes}
      rowsLength={LISTING_FORM_PORTALS_SKELETON_ROWS_LENGTH}
    />
  ) : (
    <div className={styles.PortalsFieldCheckboxGroup}>
      <div className={styles.checkboxes}>
        {portals.map(portal => (
          <PortalsFieldCheckbox
            disabled={disabled}
            disabledReason={disabledReason}
            isChecked={value.includes(portal.portal)}
            key={portal.portal}
            portal={portal}
            value={value}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  )
}

export default PortalsFieldCheckboxGroup
